// AnimalZakatTable.js
import React, { useState } from 'react';
function AnimalZakatTable({ result }) {
  let camelColSpan;
  if(result.camel.zakatDuty === 'no')
  {
    camelColSpan = 2
  } else if (result.camel.operator)
  {
    camelColSpan = 5
  } else
  {
    camelColSpan = 3
  }
  let cowColSpan;
  if(result.cow.zakatDuty === 'no')
  {
    cowColSpan = 2
  } else if (result.cow.operator)
  {
    cowColSpan = 5
  } else
  {
    cowColSpan = 3
  }
  let sheepColSpan;
  if(result.sheep.zakatDuty === 'no')
  {
    sheepColSpan = 2
  } else if (result.sheep.operator)
  {
    sheepColSpan = 5
  } else
  {
    sheepColSpan = 3
  }
  return (
    <table >
      <thead>
        <tr>
          <th >Jenis Hewan</th>
          <th colSpan={3} className="bmi-header"> Hasil</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td rowSpan={camelColSpan} >Unta</td>
        </tr>
        <tr >
          <td colSpan={2} ><b> Kewajiban Zakat	</b></td>
          <td >{result.camel.zakatDuty === 'yes' ? 'Zakat wajib atas Anda' : 'Zakat tidak wajib atas Anda'}</td>
        </tr>
        {result.camel.zakatDuty === 'yes' && (
          <tr>
            <td rowSpan={3}><b>Nilai Zakat</b> </td>
            <td colSpan={2}>{result.camel.zakatAmount_1} - {result.camel.description_ar_1}</td>
          </tr>
        )}
        {result.camel.operator && result.camel.zakatDuty === 'yes' && (
          <tr>
            <td colSpan={2}> {result.camel.operator === 'or' ? 'atau' : 'dan'}</td>
          </tr>
        )}
        {result.camel.operator && result.camel.zakatDuty === 'yes' && (
          <tr>
            <td colSpan={2}>{result.camel.zakatAmount_2} - {result.camel.description_ar_2}</td>
          </tr>
        )}
        <tr >
          <td colSpan={4} className="bmi-header">
          </td>
        </tr>
        <tr>
          <td rowSpan={cowColSpan} >Sapi</td>
        </tr>
        <tr >
          <td colSpan={2} ><b> Kewajiban Zakat	</b></td>
          <td >{result.cow.zakatDuty === 'yes' ? 'Zakat wajib atas Anda' : 'Zakat tidak wajib atas Anda'}</td>
        </tr>
        {result.cow.zakatDuty === 'yes' && (
          <tr>
            <td rowSpan={3}><b>Nilai Zakat</b> </td>
            <td colSpan={2}>{result.cow.zakatAmount_1} - {result.cow.description_ar_1}</td>
          </tr>
        )}
        {result.cow.operator && result.cow.zakatDuty === 'yes' && (
          <tr>
            <td colSpan={2}> {result.cow.operator === 'or' ? 'atau' : 'dan'}</td>
          </tr>
        )}
        {result.cow.operator && result.cow.zakatDuty === 'yes' && (
          <tr>
            <td colSpan={2}>{result.cow.zakatAmount_2} - {result.cow.description_ar_2}</td>
          </tr>
        )}
        <tr >
          <td colSpan={4} className="bmi-header">
          </td>
        </tr>
        <tr>
          <td rowSpan={sheepColSpan} >Kambing</td>
        </tr>
        <tr >
          <td colSpan={2} ><b> Kewajiban Zakat	</b></td>
          <td >{result.sheep.zakatDuty === 'yes' ? 'Zakat wajib atas Anda' : 'Zakat tidak wajib atas Anda'}</td>
        </tr>
        {result.sheep.zakatDuty === 'yes' && (
          <tr>
            <td rowSpan={3}><b>Nilai Zakat</b> </td>
            <td colSpan={2}>{result.sheep.zakatAmount_1} - {result.sheep.description_ar_1}</td>
          </tr>
        )}
        {result.sheep.operator && result.sheep.zakatDuty === 'yes' && (
          <tr>
            <td colSpan={2}> {result.sheep.operator === 'or' ? 'atau' : 'dan'}</td>
          </tr>
        )}
        {result.sheep.operator && result.sheep.zakatDuty === 'yes' && (
          <tr>
            <td colSpan={2}>{result.sheep.zakatAmount_2} - {result.sheep.description_ar_2}</td>
          </tr>
        )}
        <tr >
          <td colSpan={4} className="bmi-header">
          </td>
        </tr>
      </tbody>
    </table>
  );
}
export default AnimalZakatTable;